const AVATAR_COLORS = [
  "#03AB8C",
  "#274AE2",
  "#E02F66",
  "#8B32A8",
  "#D97706",
  "#0891B2",
  "#7C3AED",
  "#DB2777",
] as const;

/**
 * Deterministic color from a user ID. Uses a simple char-code hash so the
 * same ID always maps to the same palette entry across all surfaces.
 */
export function getUserAvatarColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!;
}
